import { Instant } from "@js-joda/core";
import { DatasetInfo } from "api/model/dataset/DatasetInfo";
import {
  AdditionalDateColumnType,
  ComponentConfigDefault,
  DatasetDefaultConfig,
  DayOfWeekDisplayType,
} from "models/dataset-models";
import { CSSProperties } from "react";

export interface IDatasetTableCommonProps {
  data: Array<any>;
  config?: ComponentConfigDefault;
  dateFrom?: Instant;
  dateTo?: Instant;
  datasetsArray: DatasetInfo[];
  totals: IDatasetTotal[];
  formatNumbers: boolean;
  setIsDialogOpen: (value: boolean) => void;
  additionalDateColumn?: AdditionalDateColumnType;
  dayOfWeekDisplayType?: DayOfWeekDisplayType;
  forceLtTz: boolean;
}

export interface IDatasetTableDefaultProps extends Omit<IDatasetTableCommonProps, "datasetsArray"> {
  dateFrom?: Instant;
  dateTo?: Instant;
  getCellStyle: (date: string, obj: any) => CSSProperties | undefined;
  datasetsArray: (DatasetDefaultConfig & { stringValueMapper?: number })[];
  additionalDateColumn?: AdditionalDateColumnType;
  dayOfWeekDisplayType?: DayOfWeekDisplayType;
}

export interface IDataArray {
  [key: string]: string | number;
}

export interface IDatasetTotal {
  identifier: string;
  value?: string;
  tooltip?: string;
}

export enum DatasetTableMode {
  SINGLE = "SINGLE",
  GROUPED = "GROUPED",
}

export interface IFlattenedDataset {
  title: string;
  identifier: string;
  unit: string;
  decimalPlaces: string;
}

export interface ColumnValueBodyStyle {
  padding: string;
  color?: string;
  backgroundColor?: string;
}
